import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { IRouterContext, RootSearch } from '@my-pages/routing/types';
import OperationalState from '@shared/features/operational-status/components/OperationalState.tsx';
import { useScrollToHash } from '@my-pages/hooks/useScrollToHash.ts';

const RootRouteComponent = () => {
    useScrollToHash();
    return (
        <>
            <OperationalState />
            <Outlet />
        </>
    );
};

const Route = createRootRouteWithContext<IRouterContext>()({
    component: RootRouteComponent,
    wrapInSuspense: true,
    validateSearch: (search: Record<string, unknown>): RootSearch => {
        // validate and parse the search params into a typed state
        return {
            grandidsession: (search?.grandidsession as string) || undefined,
            loginMethod: search?.loginMethod !== undefined ? (search.loginMethod as number) : undefined,
            returnUrl: (search?.redirectUrl as string) || undefined,
        };
    },
});

export { Route };
